import {forwardRef} from 'react';

import {RadioGroup, RadioGroupProps} from 'components/RadioGroup';

import {Block, BlockProps} from 'modules/decisionsNext/components/BaseFilter/Dialog/components/Block';

export type RadioGroupBlockProps = BlockProps & RadioGroupProps;

export const RadioGroupBlock = forwardRef<unknown, RadioGroupBlockProps>(function RadioGroupBlock(
  {label, helperText, ...radioGroupProps},
  ref
) {
  return (
    <Block label={label} helperText={helperText}>
      <RadioGroup ref={ref} {...radioGroupProps} />
    </Block>
  );
});
